const testimonials = [
  {
    name: "Shivansh Singh",
    position: "Product Operations Manager",
    company: "Chalo",
    logo: "cgii.png",
    image: "shivansh1.png",
    quote: "SkipperX truly polished my skills and helped me take on more complex challenges with confidence. The impact on my tech journey has been massive.",
    logoSize: { width: "80px", height: "65px" },
    imageSize: { width: "256px", height: "349px" }
  },
  {
    name: "Rohan Kumar",
    position: "Senior Software Engineer",
    company: "Digicert",
    logo: "02l.png",
    image: "021p.png",
    quote: "From coding lines as a junior developer to managing timelines, teams, and tech at scale as a Senior IT Project Manager — it’s been a rewarding evolution.",
    logoSize: { width: "150px", height: "42px" },
    imageSize: { width: "244px", height: "333px" }
  },
  {
    name: "Ashi Malik",
    position: "Product Manager",
    company: "Google",
    logo: "google-logo.png",
    image: "ash.png",
    quote: "SkipperX has a well-designed curriculum that helped me upskill in my core domain of Product Management. It’s highly relevant to today’s industry needs.",
    logoSize: { width: "40px", height: "49px" },
    imageSize: { width: "230px", height: "304px" }
  },
  {
    name: "Manan Singhal",
    position: "Senior IT Project Manager",
    company: "Google",
    logo: "03l.png",
    image: "lolo.png",
    quote: "Skipperx program was structured, practical, and easy to follow. The real-world approach helped me quickly bridge key skill gaps.",
    logoSize: { width: "150px", height: "34px" },
    imageSize: { width: "304px", height: "288px" }
  },
  {
    name: "Shobhit Agarwal",
    position: "Vice President",
    company: "J.P Morgan",
    logo: "04l.png",
    image: "olol.png",
    quote: "What once felt like scattered execution is now structured impact —it transformed the way I approach product operations.",
    logoSize: { width: "170px", height: "35px" },
    imageSize: { width: "280px", height: "363px" }
  }
];

export default testimonials;


